module.exports = __webpack_public_path__ + "img/Gazena_80X30.b54ab8ff.png";